import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AWS_REDSHIFT } from "../../Constants"

function ZdqAwsRedshiftConnector() {
    return <ZdqConnectorSetup vendor={AWS_REDSHIFT}></ZdqConnectorSetup>
}

export default ZdqAwsRedshiftConnector 